import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>User Centric Music App Development</h2>
            <p>
              We don’t just develop apps that help users listen to their
              favorite music, we also develop all kinds of music editing apps
              and music learning apps.
            </p>
            <p>
              Tekrevol is an award winning app Development Company and staying
              abreast of all trends is our forte and what makes us so unique and
              valued in the app development domain.
            </p>
            <p>
              We can pull in all of our resources and expertise in the arena of
              app development to create stunning user centric music app UI
              designs and UX interface, so that anyone who uses gets hooked on
              almost instantaneously.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let’s Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <StaticImage
              src="../../../images/solution/music/centric-music.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={776}
              height={735}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
